import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'

const VERSION = process.env.REACT_APP_VERSION // Předpokládáme, že aktuální verze je uložena zde
const CHECK_MINUTES = 10

const VersionChecker = () => {

  const [latestVersion, setLatestVersion] = useState('')

  const checkVersion = useCallback(async () => {
    try {
      const response = await axios.get(`/version.txt?${new Date().getTime()}`, { headers: { 'Cache-Control': 'no-cache' } })
      const fetchedVersion = response.data.trim()
      setLatestVersion(fetchedVersion)
    } catch (error) {
      console.error('Chyba při načítání verze:', error)
    }
  }, [])

  useEffect(() => {
    checkVersion() // Kontrola při prvním načtení

    // Nastavení intervalu pro pravidelnou kontrolu
    const intervalId = setInterval(checkVersion, CHECK_MINUTES * 60 * 1000)

    // Nastavení listeneru pro aktivaci okna
    const handleFocus = () => {
      checkVersion()
    }
    window.addEventListener('focus', handleFocus)

    // Cleanup funkce
    return () => {
      clearInterval(intervalId)
      window.removeEventListener('focus', handleFocus)
    }
  }, [checkVersion])

  const refreshPage = () => {
    window.location.reload() // Obnoví stránku s načtením obsahu přímo od serveru
  }

  if (!latestVersion || latestVersion === VERSION) {
    return null
  }

  return (
    <div
      title={VERSION + ' -> ' + latestVersion}
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        backgroundColor: '#fff3cd',
        padding: '10px',
        borderRadius: '5px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        zIndex: 99,
        color: 'red',
        fontWeight: 'bold'
      }}>
      <p>
        Pozor: Byla zjištěna nová verze aplikace. <br/>
        Pro načtení aktualní je třeba obnovit stránku,<br/>
        jinak nebude aplikace správně fungovat. <br/>
        Než obnovíte stránku, ujistěte se, že jste <br/>
        uložili všechna nezpracovaná data.
      </p>
      <button onClick={refreshPage} className="btn btn-primary w-100">
        Obnovit stránku
      </button>
    </div>
  )
}

export default VersionChecker
